import { createClient } from '@supabase/supabase-js';

// Project ID is managed by the connected Supabase integration.
const SUPABASE_URL = 'https://geygaguwbiivngchuhma.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdleWdhZ3V3Ymlpdm5nY2h1aG1hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTAyNjk5MzQsImV4cCI6MjEwNTg0NTkzNH0.LLi1tnZyN4hhKM79r639K25vg18QeWZM_3pMm7_BYRA';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});